import { FC } from "react";
import { useAdminConfig } from "hooks";
import BroadcastSettings from "./BroadcastSettings";
import DecimalSettings from "./DecimalSettings";
import EmailSettings from "./EmailSettings";
import InventorySettings from "./InventorySettings";
import PaymentSettings from "./PaymentSettings";
import ReturnSettings from "./ReturnSettings";

interface GeneralConfigProps {}

const GeneralConfig: FC<GeneralConfigProps> = () => {
  const config = useAdminConfig();
  const industryType = config?.industryType || "";

  return (
    <div className="font-body tracking-wider space-y-6">
      <div>
        <h3 className="text-sm font-medium">General Configuration</h3>
        <p className="text-xs text-gray-500 mt-1">
          Manage general application settings and display preferences
        </p>
      </div>

      <div className="space-y-4">
        <div className="tracking-wider bg-white p-4 rounded-md border border-gray-200">
          <div className="space-y-3">
            <div>
              <label
                htmlFor="decimal-points"
                className="block text-xs font-medium text-gray-700 mb-1"
              >
                Industry Type
              </label>
              <input
                id="industry-type"
                type="text"
                value={industryType}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-[10px] text-gray-700 cursor-not-allowed"
                aria-readonly="true"
              />
            </div>
          </div>
        </div>

        <DecimalSettings />
        {/* <OrderProcessingSettings /> */}
        <PaymentSettings />
        <InventorySettings />
        <BroadcastSettings />
        <ReturnSettings />
        <EmailSettings />
      </div>
    </div>
  );
};

export default GeneralConfig;
